export default function findSubmitButtonKey(fields) {
	return fields.reduce((accumulator, item) => {
		if ((item.type === 'submit')) {
			return item.key;
		}
		return accumulator;
	}, false);
}



// WEBPACK FOOTER //
// ./wp-content/plugins/core/assets/theme/js/src/forms/ai-enhanced-form-fields/source-form-locators/findSubmitButtonKey.js